module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-detail-aside",
    style: (_vm.styles)
  }, [_vm._t("default"), _vm._v(" "), (_vm.showMore) ? _c('rt-button-more', {
    staticClass: "rt-detail-more",
    attrs: {
      "expanded-suffix-icon": "rt-base-arrow-up-lined",
      "collapsed-suffix-icon": "rt-base-arrow-down-lined"
    },
    on: {
      "change": _vm._changeExpand
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bdf0af8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/business/detail/rtDetailAside.vue
// module id = 2123
// module chunks = 137